import React from "react";
import { FilePickerWrapperView } from "./view";
import { styles } from "./styles";

export class FilePickerWrapper extends React.Component {
  render() {
    return <FilePickerWrapperView {...this.props} styles={styles} />;
  }
}
